import PraisoServices from "./PraisoServices";
import { getToken } from "./LocalStorageService";
import { APIURL } from "../config/app-globals.enum";

export const SwitchTripAPI = async (params: any) => {
  let url = APIURL.SWITCH_TRIP_API;
  const token = getToken();
  if (params && params !== null) {
    // let tripId = '620e09e367d130e4bed6a3e9';
    // let userId = 4530;
    // url = `${url}?tripId=${tripId}&userId=${userId}`;
    url = url;
  }

  try {
    // const apiResponse = getAPIResponse(url);
    // if (apiResponse !== null) {
    //   return apiResponse;
    // }
    const response = await PraisoServices(
      url,
      "post",
      { ...params },
      {},
      {
        Authorization: `Bearer ${token}`
      }
    );
    try {
      //   setAPIResponse(url, response);
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};


export const switchTrip = async (params: { tripId: string, tripType: number, tripSubType: number }) => {
  const data = await SwitchTripAPI(params);
  return data;
};

